import { useCallback, useEffect, useState } from 'react';

import { fetchTeachers, fetchUsers } from 'lib/models/users';

function useUsers(type: UserAdminType | UserTeacherType = 'admin', school?: string) {
	const [loading, setLoading] = useState<boolean>(true);
	const [users, setUsers] = useState<User[]>([]);

	const refetch = useCallback(async () => {
		const response = await (type === 'admin' ? fetchUsers() : fetchTeachers(school));
		setUsers(response);
		setLoading(false);
	}, [type, school]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	const usersIds = users.map(({ _id }) => _id).join(',');

	const addUsers = useCallback(
		(teachers: User[]) => {
			setUsers((currentUsers) => {
				return [
					// Update existing users
					...currentUsers.map((current) => {
						const found = teachers.find((teacher) => teacher._id === current._id);
						return found || current;
					}),
					// Add new users
					...teachers.filter((user) => user._id && !usersIds.includes(user._id)),
				];
			});
			setLoading(false);
		},
		[usersIds]
	);

	return { loading, users, refetch, addUsers, setLoading };
}

export default useUsers;
